
























































































































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";
import Customer from "@/types/customer/Customer";
import Endpoint from "@/utils/endpoint";

const namespace = "customer";

@Component({})
export default class ModalRefuse extends Vue {
  @Getter("getCustomer", { namespace }) customer!: Customer;
  @Getter("getModalRefuseState", { namespace }) modalRefuseState!: boolean;
  @Action('setModalCreateInterestState', { namespace: 'customer' })
  setModalCreateInterestState!: any;
  @Action("setModalRefuseState", { namespace }) setModalRefuseState!: any;
  @Action("setModalInterestState", { namespace }) setModalInterestState!: any;
  @Action("removeCustomerFromList", { namespace }) removeCustomerFromList!: any;

  private endpoint = new Endpoint();

  refusing = false;
  successRefused = false;
  commentForRefuse = "";

  requiredRules: Array<any> = [
    (v: string) => {
      return !!v || "Required field";
    }
  ];

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  refuseClient(): void {
    if (this.form) {
      this.refusing = true;
      this.$http
        .put(this.endpoint.refuseCustomer, {
          refuseCustomer: {
            customerId: this.customer.id,
            comment: this.commentForRefuse
          }
        })
        .then(resp => {
          this.customer.refuseComment = this.commentForRefuse;
          this.commentForRefuse = "";

          this.refusing = false;

          this.successRefused = true;
          this.removeCustomerFromList({
            id: this.customer.id,
            status: 2,
            evaluator: resp.data.evaluator
          });
          this.setModalInterestState(false);
          this.setModalRefuseState(false);
          this.setModalCreateInterestState(false);
        })
        .catch(err => {
          this.refusing = false;
          console.error("error", err);
        });
    }
  }

  closeRefusement(): void {
    if (!this.refusing) {
      this.commentForRefuse = "";
      this.setModalRefuseState(false);
    }
  }
}
